export default "__VITE_ASSET__CSU$pnEf__"